// Production API configuration pointing to the dedicated API worker
const getApiBaseUrl = () => {
  if (typeof window !== 'undefined') {
    // Always prefer environment variable for production reliability
    const envApiUrl = import.meta.env.VITE_API_BASE_URL;
    if (envApiUrl) {
      return envApiUrl;
    }
    
    // For localhost development only
    const currentHost = window.location.hostname;
    if (currentHost.includes('localhost')) {
      return `${window.location.protocol}//${window.location.host}`;
    }
    
    // Fallback to the deployed worker URL - this is reliable across deployments
    return 'https://formcraft-api-worker.evercore-digital-solutions-llp.workers.dev';
  }
  return '';
};

const API_BASE_URL = getApiBaseUrl();

export interface Form {
  id: string;
  name: string;
  description?: string;
  status: 'draft' | 'published';
  created_at: string;
  fields?: Field[];
  submission_count?: number;
}

export interface Field {
  id: string;
  form_id: string;
  type: 'text' | 'email' | 'url' | 'number' | 'textarea' | 'select';
  label: string;
  placeholder?: string;
  required: boolean;
  validation_regex?: string;
  validation_message?: string;
  disabled_domains?: string[];
  field_options?: string[];
  order_index: number;
}

export interface FormSubmission {
  id: string;
  form_id: string;
  field_responses: Record<string, string>;
  submitted_at: string;
}

// Form APIs (only read operations needed for embed)
export async function getForm(id: string): Promise<Form> {
  const response = await fetch(`${API_BASE_URL}/api/forms/${id}`);
  if (!response.ok) throw new Error('Failed to fetch form');
  return response.json();
}

// Submission APIs
export async function submitResponse(formId: string, responses: Record<string, string>): Promise<void> {
  const response = await fetch(`${API_BASE_URL}/api/forms/${formId}/submit`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ field_responses: responses })
  });
  if (!response.ok) throw new Error('Failed to submit form');
}